import { render, staticRenderFns } from "./block-credit-new.vue?vue&type=template&id=359533d3&scoped=true"
import script from "./block-credit-new.vue?vue&type=script&lang=js"
export * from "./block-credit-new.vue?vue&type=script&lang=js"
import style0 from "./block-credit-new.vue?vue&type=style&index=0&id=359533d3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359533d3",
  null
  
)

export default component.exports